import React from 'react'

const IntegrationSettings = () => {
  return (
    <div>IntegrationSettings</div>
  )
}

export default IntegrationSettings